import { useState } from "react";
import { http } from "../lib/api";
import { inr } from "../lib/format";

const STAGES = ["Pending", "Confirmed", "Processing", "Shipped", "Delivered"];

export default function OrderTracking() {
  const [num, setNum] = useState("");
  const [contact, setContact] = useState("");
  const [order, setOrder] = useState(null);
  const [err, setErr] = useState("");

  const track = async (e) => {
    e.preventDefault();
    setErr(""); setOrder(null);
    try {
      const r = await http.get(`/orders/track?order_number=${encodeURIComponent(num)}&contact=${encodeURIComponent(contact)}`);
      setOrder(r.data);
    } catch { setErr("Order not found. Check your order number and email/phone."); }
  };

  const stageIdx = order ? STAGES.indexOf(order.status) : -1;

  return (
    <div className="max-w-2xl mx-auto px-4 py-16">
      <h1 className="font-display text-5xl sm:text-6xl text-white uppercase tracking-tight mb-6">Track Order</h1>
      <form onSubmit={track} className="space-y-3">
        <input required placeholder="Order number (e.g. SS0001)" value={num} onChange={(e) => setNum(e.target.value.toUpperCase())}
          className="w-full bg-zinc-950 border border-zinc-800 px-4 py-3.5 text-sm focus:border-accent-ss" data-testid="track-number-input" />
        <input required placeholder="Email or phone used at checkout" value={contact} onChange={(e) => setContact(e.target.value)}
          className="w-full bg-zinc-950 border border-zinc-800 px-4 py-3.5 text-sm focus:border-accent-ss" data-testid="track-contact-input" />
        <button className="btn-accent w-full py-4 text-sm font-bold uppercase tracking-wider" data-testid="track-submit-btn">Track</button>
      </form>
      {err && <p className="text-red-400 text-sm mt-4">{err}</p>}

      {order && (
        <div className="mt-8 bg-zinc-900/50 border border-zinc-800 p-6" data-testid="track-result">
          <div className="flex justify-between items-center mb-6">
            <span className="font-display text-2xl text-white">{order.order_number}</span>
            <span className="text-xs uppercase tracking-wider text-accent border border-accent-ss px-3 py-1" style={{ borderColor: "var(--ss-accent)" }}>{order.status}</span>
          </div>
          {stageIdx >= 0 && order.status !== "Cancelled" && (
            <div className="flex justify-between mb-8">
              {STAGES.map((s, i) => (
                <div key={s} className="flex-1 flex flex-col items-center">
                  <div className={`w-3 h-3 rounded-full ${i <= stageIdx ? "" : "bg-zinc-700"}`} style={i <= stageIdx ? { background: "var(--ss-accent)" } : {}} />
                  <span className={`text-[9px] mt-2 uppercase tracking-wide ${i <= stageIdx ? "text-zinc-200" : "text-zinc-600"}`}>{s}</span>
                </div>
              ))}
            </div>
          )}
          <div className="space-y-2">
            {order.items.map((it, i) => (
              <div key={i} className="flex justify-between text-sm">
                <span className="text-zinc-300">{it.name} ×{it.qty}</span>
                <span className="text-white">{inr(it.line_total)}</span>
              </div>
            ))}
          </div>
          <div className="flex justify-between font-bold text-white pt-3 mt-3 border-t border-zinc-800"><span>Total</span><span>{inr(order.total)}</span></div>
        </div>
      )}
    </div>
  );
}
